var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "../../box/Box";
import Text from "../../text/Text";
function PriceLabel(_a) {
    var product = _a.product, rest = __rest(_a, ["product"]);
    var isOnSale = product.sale_discount_ratio > 0;
    var saleText = isOnSale ? "".concat((product.sale_discount_ratio * 100).toFixed(), "% off") : "";
    return (React.createElement(Box, __assign({}, rest), product.sale_discount_ratio === 1 ? (React.createElement(Box, null,
        React.createElement(Text, { display: "inline-block", fontWeight: "bold", fontSize: 4 }, "FREE"))) : (React.createElement(Box, null,
        isOnSale && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "sr-only" }, "Normally,"),
            React.createElement(Text, { typeStyle: "text03", display: "inline-block", textDecoration: "line-through", color: "grays.4", mr: 2, as: "p" }, product.price_msrp),
            React.createElement("span", { className: "sr-only" }, "Your price today,"))),
        React.createElement(Text, { display: "inline-block", typeStyle: "text03", as: "p" }, product.price),
        isOnSale && (React.createElement(Text, { display: "inline-block", typeStyle: "text03", fontWeight: "bold", color: "grays.4", ml: 2, as: "p" }, saleText))))));
}
export default PriceLabel;
//# sourceMappingURL=PriceLabel.js.map